import { useContext, useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router';
import { GlobalContext } from '../../../context/Context';
import Style from './style.module.css';
import { motion, AnimatePresence } from "framer-motion";
import { ChevronsRight } from 'lucide-react';

const AsideBar = () => {
    const location = useLocation();
    let { state } = useContext(GlobalContext);
    const [one] = useState(1);
    let dashboardRole = state?.user?.dashboardRole === "single";

    const navItems = [
        {
            title: "Dashboard",
            url: dashboardRole ? "#" : "/my-space/overview",
            isActive: location.pathname.split("/")[one] === "my-space" || location.pathname.split("/")[one] === "organization" || location?.pathname?.split("/")[one] === "team",
            icon: `${state.basePath}/dashboard/aside/png/home.png`,
            iconHover: `${state.basePath}/dashboard/aside/png/home-hover.png`,
            subMenu: false,
        },
        {
            title: "Bills",
            url: dashboardRole ? "#" : `/bills/all`,
            isActive: location.pathname.split("/")[one] === "bills",
            icon: `${state.basePath}/dashboard/aside/png/reports.png`,
            iconHover: `${state.basePath}/dashboard/aside/png/reports-hover.png`,
            subMenu: false,
        },
        {
            title: "Ledger",
            url: dashboardRole ? "#" : `/ledger/all`,
            isActive: location.pathname.split("/")[one] === "ledger",
            icon: `${state.basePath}/dashboard/aside/png/tracker.png`,
            iconHover: `${state.basePath}/dashboard/aside/png/tracker-hover.png`,
            subMenu: false,
        },
        {
            title: "Reports",
            url: dashboardRole ? "#" : `/reports/all`,
            isActive: location.pathname.split("/")[one] === "reports",
            icon: `${state.basePath}/dashboard/aside/png/reports.png`,
            iconHover: `${state.basePath}/dashboard/aside/png/reports-hover.png`,
            subMenu: false,
        },
        {
            title: "config",
            url: dashboardRole ? "#" : `/configuration/all`,
            isActive: location.pathname.split("/")[one] === "configuration",
            icon: `${state.basePath}/dashboard/aside/png/config.png`,
            iconHover: `${state.basePath}/dashboard/aside/png/config-hover.png`,
            subMenu: false,
        },
    ].filter(Boolean);

    const allMenus = {
        "hrms": navItems,
    }

    const [expend, setExpend] = useState(false);
    const [activeNav, setActiveNav] = useState([]);

    const expendFind = (idx) => {
        if (expend) {
            setActiveNav((prev, i) => prev.includes(idx) ? prev.filter((v) => v !== idx) : [...prev, idx]);
        }
    }

    const [showSubMenu, setShowSubMenu] = useState(false);

    const [selectedMenu, setSelectedMenu] = useState("hrms");

    useEffect(() => {
        const splittedLocation = location.pathname?.split("/");
        // console.log("splittedLocation", )
        if (splittedLocation?.includes("tools")) {
            setSelectedMenu(splittedLocation[splittedLocation.indexOf("tools") + 1])
        } else {
            setSelectedMenu("hrms")
        }
    }, [location.pathname])

    useEffect(() => {
        let timer;

        if (!expend) {
            timer = setTimeout(() => {
                setShowSubMenu(true);
            }, 200);
        } else {
            setShowSubMenu(false);
        }

        return () => clearTimeout(timer);
    }, [expend]);

    return (
        <motion.aside
            className={expend ? `${Style.isExpend} isExpend` : ""}
            animate={{ width: expend ? 187 : 78 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        >
            <div className={`${Style.aside_top}`}>
                <div className="px-[10px] w-full h-fit flex-shrink-0 overflow-hidden">
                    <div className={`${Style.aside_userProfle}`}>
                        <div className="icon">
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="31" height="37" viewBox="0 0 31 37" fill="none">
                                <path d="M20.0989 5.95C22.5725 5.95011 24.595 7.91437 24.595 10.7225C24.5949 12.2558 23.8384 13.8443 22.7952 14.7117L22.4436 15.0037L22.8782 15.1424C25.3911 15.9447 26.8242 17.7399 27.6331 19.5955C28.4441 21.4563 28.6204 23.3634 28.6204 24.3377C28.6204 25.4617 28.6084 26.3894 27.6282 27.0896C27.1218 27.4513 26.3399 27.7643 25.1252 27.9852C23.9122 28.2057 22.2836 28.3318 20.0989 28.3318C17.914 28.3318 16.2856 28.2057 15.0725 27.9852C13.8579 27.7643 13.076 27.4513 12.5696 27.0896C11.5893 26.3894 11.5774 25.4617 11.5774 24.3377C11.5774 23.3575 11.7375 21.39 12.5325 19.4705C13.3256 17.5555 14.741 15.7071 17.2463 14.9061L17.6809 14.7674L17.3303 14.4754C16.2839 13.6054 15.6019 12.2518 15.6018 10.7225C15.6018 8.07542 17.6305 5.95 20.0989 5.95Z" fill="url(#paint0_linear_7997_3451)" stroke="white" strokeWidth="0.5" />
                                <g filter="url(#filter0_d_7997_3451)">
                                    <path d="M15.3271 14.904C16.4301 13.9871 17.218 12.3269 17.218 10.7223C17.218 7.78394 15.0908 5.7 12.4712 5.7C9.85166 5.7 7.7245 7.95066 7.7245 10.7223C7.7245 12.3269 8.44012 13.7509 9.54309 14.6679C4.34992 16.3281 3.69995 22.3367 3.69995 24.3373C3.69995 26.5602 3.69995 28.5816 12.4712 28.5816C21.2425 28.5816 21.2425 26.5602 21.2425 24.3373C21.2425 22.3437 20.5269 16.5642 15.3271 14.904Z" fill="url(#paint1_linear_7997_3451)" />
                                    <path d="M12.4714 5.95C14.9451 5.95011 16.9675 7.91437 16.9675 10.7225C16.9675 12.2558 16.2109 13.8443 15.1677 14.7117L14.8162 15.0037L15.2507 15.1424C17.7637 15.9447 19.1968 17.7399 20.0056 19.5955C20.8167 21.4563 20.9929 23.3634 20.9929 24.3377C20.9929 25.4617 20.981 26.3894 20.0007 27.0896C19.4944 27.4513 18.7125 27.7643 17.4978 27.9852C16.2847 28.2057 14.6562 28.3318 12.4714 28.3318C10.2866 28.3318 8.65817 28.2057 7.44507 27.9852C6.23042 27.7643 5.44854 27.4513 4.94214 27.0896C3.96189 26.3894 3.94995 25.4617 3.94995 24.3377C3.94995 23.3575 4.11005 21.39 4.90503 19.4705C5.69816 17.5555 7.11354 15.7071 9.6189 14.9061L10.0535 14.7674L9.70288 14.4754C8.65649 13.6054 7.97442 12.2518 7.97437 10.7225C7.97437 8.07542 10.003 5.95 12.4714 5.95Z" stroke="url(#paint2_linear_7997_3451)" strokeWidth="0.5" />
                                </g>
                                <defs>
                                    <filter id="filter0_d_7997_3451" x="-4.86374e-05" y="9.53674e-07" width="30.9425" height="36.2816" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dx="3" dy="1" />
                                        <feGaussianBlur stdDeviation="3.35" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix" values="0 0 0 0 0.145098 0 0 0 0 0.388235 0 0 0 0 0.921569 0 0 0 1 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_7997_3451" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_7997_3451" result="shape" />
                                    </filter>
                                    <linearGradient id="paint0_linear_7997_3451" x1="17.3765" y1="4.13989" x2="31.5838" y2="18.4441" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="white" />
                                        <stop offset="1" stopColor="#0B54FF" />
                                    </linearGradient>
                                    <linearGradient id="paint1_linear_7997_3451" x1="20.8235" y1="17.1408" x2="3.8429" y2="17.1408" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#BCBCBC" />
                                        <stop offset="1" stopColor="white" />
                                    </linearGradient>
                                    <linearGradient id="paint2_linear_7997_3451" x1="3.90879" y1="26.8867" x2="17.7797" y2="16.231" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#335CFF" />
                                        <stop offset="1" stopColor="white" />
                                    </linearGradient>
                                </defs>
                            </svg> */}

                            <svg width="31" height="37" viewBox="0 0 32 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g filter="url(#filter0_d_8562_2413)">
                                    <path d="M20.2888 36.639C20.6061 36.4632 20.8703 36.2055 21.054 35.8927C21.2376 35.5799 21.3339 35.2235 21.3328 34.8608L21.3328 15.5827C21.3328 14.9327 21.122 14.3003 20.732 13.7803C20.342 13.2603 19.7939 12.8808 19.17 12.6988L6.08722 8.88305C5.39852 8.68216 4.79355 8.26332 4.36312 7.68939C3.93268 7.11546 3.70001 6.4174 3.70002 5.7L3.70002 29.9435C3.70002 30.6611 3.93276 31.3593 4.36329 31.9333C4.79382 32.5073 5.39892 32.9263 6.08777 33.1272L18.6465 36.7903C18.9166 36.8755 19.2009 36.906 19.4829 36.88C19.7649 36.8541 20.0388 36.7721 20.2888 36.639Z" fill="url(#paint0_linear_8562_2413)" />
                                    <path d="M21.0828 15.5828L21.0828 34.8611C21.0838 35.1791 20.9996 35.4922 20.8386 35.7664C20.6977 36.0064 20.5022 36.209 20.2693 36.3592L20.1677 36.4207C19.9481 36.537 19.7072 36.6079 19.4597 36.6307C19.2109 36.6536 18.9597 36.6268 18.7214 36.5516L18.7166 36.5506L6.15796 32.8875C5.52104 32.7017 4.96131 32.3138 4.56323 31.783C4.16526 31.2523 3.94995 30.6065 3.94995 29.9432L3.94995 7.51641C4.01553 7.62709 4.08508 7.73596 4.16284 7.83965C4.62573 8.45683 5.27672 8.90682 6.01733 9.12285L19.1003 12.9393C19.6722 13.1062 20.1746 13.4539 20.532 13.9305C20.8894 14.4072 21.0828 14.987 21.0828 15.5828Z" stroke="url(#paint1_linear_8562_2413)" stroke-width="0.5" />
                                </g>
                                <g filter="url(#filter1_d_8562_2413)">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7 24.5037C12.515 24.5037 12.3525 24.4065 12.2662 24.2625C11.92 23.6889 11.155 23.4933 10.5575 23.8257C9.96121 24.1569 9.75745 24.8913 10.1024 25.4649C10.4124 25.9797 10.8837 26.3925 11.45 26.6421V27.1437C11.45 27.8061 12.01 28.3437 12.7 28.3437C13.39 28.3437 13.95 27.8061 13.95 27.1437V26.6421C14.9824 26.1873 15.7 25.1853 15.7 24.0237C15.7 22.6005 14.8474 21.9021 13.7087 21.4353C13.3224 21.2769 12.8975 21.1533 12.5262 20.9817C12.375 20.9121 12.1999 20.8605 12.1999 20.6637C12.1999 20.3985 12.4237 20.1837 12.7 20.1837C12.885 20.1837 13.0475 20.2809 13.1337 20.4249C13.48 20.9985 14.2449 21.1941 14.8424 20.8617C15.4387 20.5305 15.6425 19.7961 15.2975 19.2225C14.9875 18.7077 14.5162 18.2949 13.95 18.0453V17.5437C13.95 16.8813 13.39 16.3437 12.7 16.3437C12.01 16.3437 11.45 16.8813 11.45 17.5437V18.0453C10.4175 18.5001 9.69995 19.5021 9.69995 20.6637C9.69995 22.0869 10.5525 22.7853 11.6912 23.2521C12.0775 23.4105 12.5025 23.5341 12.8737 23.7057C13.025 23.7753 13.2 23.8269 13.2 24.0237C13.2 24.2889 12.9762 24.5037 12.7 24.5037Z" fill="white" />
                                </g>
                                <path d="M28.8645 7.05657L28.8645 14.7607C28.8645 15.2268 28.761 15.6874 28.5608 16.1083C28.3606 16.5292 28.0688 16.9002 27.7073 17.1943L26.0676 18.5273C25.8821 18.6782 25.7329 18.8689 25.6301 19.0849C25.5274 19.3009 25.4739 19.5371 25.4739 19.7763L25.4739 30.1142C25.4739 30.7673 25.214 31.3945 24.7522 31.8564C24.2904 32.3181 23.664 32.577 23.011 32.5771L22.5823 32.5771L22.5823 15.58C22.5794 14.5836 22.2555 13.6143 21.6575 12.8173C21.0966 12.0699 20.3231 11.5114 19.4407 11.2128L19.2629 11.1572L6.18091 7.33879C5.82643 7.23479 5.51505 7.01895 5.29321 6.72356C5.07152 6.42833 4.95161 6.0693 4.95044 5.70012L4.95532 5.59075C4.98045 5.33756 5.09226 5.09943 5.27368 4.91789C5.48107 4.71051 5.76263 4.59378 6.05591 4.59368L26.4016 4.59368C27.0548 4.59368 27.681 4.85351 28.1428 5.31536C28.547 5.71958 28.7969 6.24946 28.8528 6.8134L28.8645 7.05657Z" fill="url(#paint2_linear_8562_2413)" stroke="white" stroke-width="0.5" />
                                <defs>
                                    <filter id="filter0_d_8562_2413" x="-4.86374e-05" y="0" width="31.0328" height="44.589" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dx="3" dy="1" />
                                        <feGaussianBlur stdDeviation="3.35" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.619608 0 0 0 0 0.290196 0 0 0 1 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8562_2413" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8562_2413" result="shape" />
                                    </filter>
                                    <filter id="filter1_d_8562_2413" x="7.69995" y="14.3437" width="14" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                        <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                        <feOffset dx="2" dy="2" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite in2="hardAlpha" operator="out" />
                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8562_2413" />
                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8562_2413" result="shape" />
                                    </filter>
                                    <linearGradient id="paint0_linear_8562_2413" x1="12.5164" y1="36.1441" x2="12.5164" y2="5.95416" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#BCBCBC" />
                                        <stop offset="1" stop-color="white" />
                                    </linearGradient>
                                    <linearGradient id="paint1_linear_8562_2413" x1="5.00615" y1="6.0713" x2="21.789" y2="15.5405" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="#FF9E4A" />
                                        <stop offset="1" stop-color="white" />
                                    </linearGradient>
                                    <linearGradient id="paint2_linear_8562_2413" x1="7.69995" y1="-13.6563" x2="18.6353" y2="28.2942" gradientUnits="userSpaceOnUse">
                                        <stop stop-color="white" />
                                        <stop offset="1" stop-color="#FF9E4A" />
                                    </linearGradient>
                                </defs>
                            </svg>

                        </div>

                        <div className="text-white text-[11px] font-semibold leading-[1]">Book</div>
                    </div>
                </div>

                <div className={`${Style?.aside_navBar} ${expend ? Style?.aside_navBar_expend : ""}`}>
                    {allMenus[selectedMenu]?.map((item, idx) => {
                        return (
                            <div
                                key={`nav_row_${idx}`}
                                className={`${Style?.nav_row}`}
                            >
                                <motion.div
                                    onClick={() => { if (item?.subMenu) { expendFind(idx); } }}
                                    className={`${Style?.nav_button}`}
                                    animate={{
                                        flexDirection: expend ? "row" : "column",
                                        alignItems: expend ? "center" : "center",
                                        gap: expend ? "10px" : "10px"
                                    }}
                                    transition={{ duration: 0.25, ease: "easeInOut" }}
                                >
                                    <Link to={item?.url} className={`${Style?.nav_link} ${(activeNav?.includes(idx) && expend) ? Style.active : null} ${item?.isActive ? Style.active : ""} `}>
                                        <div className={`${Style?.icon}`}><img src={`${item?.icon}`} width={46} height={46} alt={`normal_${idx}_${item?.title}`} /></div>
                                        <div className={`${Style?.icon} ${Style?.iconHover}`}><img src={item?.iconHover} width={46} height={46} alt={`hover_${idx}_${item?.title}`} /></div>
                                    </Link>

                                    <AnimatePresence mode="wait">
                                        <motion.span
                                            key={expend ? "expanded" : "collapsed"}
                                            className={`${Style.nav_lable} truncate ${activeNav?.includes(idx) && expend ? Style.active : null} ${item?.isActive ? Style.active : ""} `}
                                            initial={{
                                                opacity: 0,
                                                x: expend ? -3 : 0,
                                                y: expend ? 0 : 3,
                                            }}
                                            animate={{ opacity: 1, x: 0, y: 0 }}
                                            exit={{
                                                opacity: 0,
                                                x: expend ? -3 : 0,
                                                y: expend ? 0 : 3,
                                            }}
                                            transition={{ duration: 0.15, ease: "easeOut" }}
                                        >
                                            {item.title}
                                        </motion.span>
                                    </AnimatePresence>
                                </motion.div>

                                {item?.subMenu && (
                                    expend ? (
                                        // "expanded"
                                        <div className={`${Style.nav_subMenuWrapp2} ${activeNav?.includes(idx) ? Style?.isOpen : null}`}>
                                            <div className={`${Style?.nav_subMenuBody}`}>
                                                {item?.subMenuList?.map((subItems, subIdx) => {
                                                    const isActive = location?.pathname?.split("/").length > 3 ? `${location?.pathname?.split("/")[1]}-${location?.pathname?.split("/")[2]}` == `${subItems?.url?.split("/")[1]}-${subItems?.url?.split("/")[2]}` : `${location?.pathname?.split("/")[1]}` == `${subItems?.url?.split("/")[1]}`
                                                    return (
                                                        <Link to={subItems?.url || "#"} className={`${Style?.nav_subMenuItems} ${isActive ? Style?.isActive : null}`} key={`subMenu_${idx}_${subIdx}`}>{subItems?.title}</Link>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    ) : (
                                        showSubMenu &&
                                        <div className={`${Style.nav_subMenuWrapp}`}>
                                            <div className={`${Style?.nav_subMenuHead}`}>
                                                <img className={`${Style?.nav_subMenuIcon}`} src={`${item?.icon}`} width={26} height={26} alt={item?.title} />
                                                <span className={`${Style?.nav_subMenuLable}`}>{item?.title}</span>
                                            </div>

                                            <div className={`${Style?.nav_subMenuBody}`}>
                                                {item?.subMenuList?.map((subItems, subIdx) => {
                                                    const isActive = location?.pathname?.split("/").length > 3 ? `${location?.pathname?.split("/")[1]}-${location?.pathname?.split("/")[2]}` == `${subItems?.url?.split("/")[1]}-${subItems?.url?.split("/")[2]}` : `${location?.pathname?.split("/")[1]}` == `${subItems?.url?.split("/")[1]}`
                                                    return (
                                                        <Link to={subItems?.url || "#"} className={`${Style?.nav_subMenuItems} ${isActive ? Style?.isActive : null}`} key={`subMenu_${idx}_${subIdx}`}>{subItems?.title}</Link>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className={Style.aside_bottom}>
                <motion.button
                    type="button"
                    className={Style.collapseBtn}
                    onClick={() => {
                        setTimeout(() => {
                            setExpend(prev => !prev);
                        }, 5);
                    }}
                    whileHover={{ scale: 1.08 }}
                    whileTap={{ scale: 0.92 }}
                    aria-label={expend ? "Collapse sidebar" : "Expand sidebar"}
                    title={expend ? "Collapse sidebar" : "Expand sidebar"}
                >
                    <motion.span
                        animate={{ rotate: expend ? 180 : 0 }}
                        transition={{ duration: 0.25, ease: "easeInOut" }}
                    >
                        <ChevronsRight size={18} strokeWidth={2.2} />
                    </motion.span>
                </motion.button>
            </div>
        </motion.aside >
    )
}

export default AsideBar
